import { MaterialType } from "../../../types/materials";

export enum EditorialTextTitleSizes {
  LG = "large",
  MD = "regular",
  SM = "small",
  XS = "extra-small",
}

export enum EditorialTextBodySizes {
  MD = "regular",
  SM = "small",
}

export enum EditorialTextBaseColors {
  LIGHT = "light-background",
  PRIMARY = "primary-background",
  NEUTRAL = "neutral-background",
}

export type EditorialTextColors = EditorialTextBaseColors | MaterialType;

export enum EditorialTextAlignments {
  LEFT = "left",
  CENTER = "center",
}
